import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/web.dom.iterable";
import _classCallCheck from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/classCallCheck";
import _inherits from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Extensions
import { Service } from "../service"; // Utilities

import { mergeDeep } from "../../util/helpers"; // Presets

import presets from "./presets";
export var Icons = /*#__PURE__*/function (_Service) {
  _inherits(Icons, _Service);

  var _super = _createSuper(Icons);

  function Icons(preset) {
    var _this;

    _classCallCheck(this, Icons);

    _this = _super.call(this);
    var _preset$Icons$propert = preset[Icons.property],
        iconfont = _preset$Icons$propert.iconfont,
        values = _preset$Icons$propert.values,
        component = _preset$Icons$propert.component;
    _this.component = component;
    _this.iconfont = iconfont;
    _this.values = mergeDeep(presets[iconfont], values);
    return _this;
  }

  return Icons;
}(Service);
Icons.property = 'icons';